import http from '../http'

export default {
    all(usuario) {
        return http.get(`usuarios/${usuario}/cursos`)
    }
}